export class BrandMiniEntity {
  id?: number
  name?: string | null
  profileImageUrl?: string | null
  createdAt?: string | null
}
